module.exports = __webpack_public_path__ + "img/04.8c0c2499.png";